var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudentBoxShortVertical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 130,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#B6B6B6",
    fill: "#EDEDED",
    x: 0.5,
    y: 0.5,
    width: 231,
    height: 129,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 11,
    y: 11,
    width: 211,
    height: 109,
    rx: 3
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 16,
    fill: "#B6B6B6"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 24,
    y: 38
  }, "Student answer.")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentBoxShortVertical);
export default __webpack_public_path__ + "static/media/student-box-short-vertical.a6afcf932cb2ea1f23bee403ae477e49.svg";
export { ForwardRef as ReactComponent };